module.exports = __webpack_public_path__ + "static/media/add-file.96e3734a.png";